import { Expense, ExpenseKindEnum, Hospitality, Mileage, PerDiem } from "@finway-group/shared/lib/models"
import { Modal, Tabs } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useLoggedInEmployeeProfile } from "Shared/hooks/user.hooks"
import DatevCompatibilityBanner from "./datevCompatibilityBanner"
import ExpenseTransactionList from "./expenseTransaction.list"
import MainDetailsSectionWrapper from "./mainDetailsSection.wrapper"
import MainDetailsSection from "./mainDetailsSection.component"
import { HospitalityMainDetailsSection } from "./reimbursementComponents/hospitalityMainDetailsSection.component"
import { MileageMainDetailsSection } from "./reimbursementComponents/mileageMainDetailsSection.component"
import { PerDiemMainDetailsSection } from "./reimbursementComponents/perDiemMainDetailsSection.component"

interface MainDetailsTabsInterface {
    expense: Expense
    setIsExpenseUpdating: React.Dispatch<React.SetStateAction<boolean>>
    setIsEditModalShowing: React.Dispatch<React.SetStateAction<boolean>>
}
const MainDetailsTabs: React.FC<MainDetailsTabsInterface> = ({ expense, setIsExpenseUpdating, setIsEditModalShowing }) => {
    const { t } = useTranslation()
    const loggedInProfile = useLoggedInEmployeeProfile()

    const renderExpenseMainDetailSection = (expenseKind: ExpenseKindEnum) => {
        switch (expenseKind) {
            case ExpenseKindEnum.MILEAGE:
                return <MileageMainDetailsSection expense={expense as Mileage} />
            case ExpenseKindEnum.PER_DIEM:
                return <PerDiemMainDetailsSection expense={expense as PerDiem} />
            case ExpenseKindEnum.HOSPITALITY:
                return <HospitalityMainDetailsSection expense={expense as Hospitality} />
            default:
                return <MainDetailsSectionWrapper expense={expense} openEditModal={() => setIsEditModalShowing(true)} setIsExpenseUpdating={setIsExpenseUpdating} />
        }
    }

    return (
        <Tabs className="w-full min-h-200 ml-1">
            <Tabs.TabPane key="requestDetails" tab={t("label:request_details")}>
                <DatevCompatibilityBanner expense={expense} />
                {renderExpenseMainDetailSection(expense.kind)}
            </Tabs.TabPane>
            {loggedInProfile.activeCompanyProfile.isAdmin && (
                <Tabs.TabPane key="transactions" tab={t("label:transactions")}>
                    <ExpenseTransactionList expense={expense} />
                </Tabs.TabPane>
            )}
        </Tabs>
    )
}

export default React.memo(MainDetailsTabs)
